












































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ImageModal from '@/app/components/Common/ImageModal.vue'
import MachineSearch from '@/app/components/Machine/MachineSearch.vue'
import MachineListHeader from '@/app/components/Machine/MachineListHeader.vue'
import MachineList from '@/app/components/Machine/MachineList.vue'
/* api */
import MachineListApi from '@/app/model/api/machineListApi'
import GetMachineImgApi from '@/app/model/api/getMachineImgApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    MachineSearch,
    MachineListHeader,
    MachineList,
    ImageModal
  }
})
export default class varietyGrowth extends Vue {
  private totalCount: number = 0
  private notDataMessage: boolean = false
  private showList: boolean = false
  private showLoading: boolean = true
  private machineData: any = {}
  private isRequesting: boolean = true
  private showModal: boolean = false
  private modalImgPath: string = ''

  created () {
    this.getMachineList()
  }

  private getMachineList () {
    (async () => {
      const data = {
        word: this.$store.state.machineState.searchText,
        order_name: this.$store.state.machineState.orderName,
        sort: this.$store.state.machineState.sortAsc,
        is_valid: this.$store.state.machineState.isValid,
        machine_type: this.$store.state.machineState.machineType
      }

      const result = await MachineListApi.getMachineList(data)

      if (result.isOk()) {
        this.machineData = result.getPayload().results
        this.totalCount = result.getPayload().total_count

        if (this.totalCount === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
      this.isRequesting = false
    })()
  }

  private doMachineSort (data: string) {
    this.isRequesting = true
    this.showLoading = true
    this.scrollTop()

    let sort = false
    if (data === this.$store.state.machineState.orderName) {
      if (this.$store.state.machineState.sortAsc === true) {
        sort = false
      } else {
        sort = true
      }
    } else {
      sort = true
    }

    this.$store.commit('machineState/setOrderName', data)
    this.$store.commit('machineState/setSortAsc', sort)
    this.getMachineList()
  }

  private changeList () {
    this.isRequesting = true
    this.showLoading = true
    this.$store.commit('machineState/setOrderName', 'created_at')
    this.$store.commit('machineState/setSortAsc', false)
    this.scrollTop()
    this.getMachineList()
  }

  private scrollTop () : any {
    const listArea: any = document.getElementById('listContainer')!
    listArea.scrollTop = 0
  }

  private async getDefaultImg (id: string) {
    const result = await GetMachineImgApi.getMachineImgData(id)
    if (typeof result === 'object') {
      this.modalImgPath = require('@/assets/img/no_image.svg')
    } else {
      this.modalImgPath = String(result)
    }
    this.showLoading = false
  }

  private showImgModal (id: string) {
    this.getDefaultImg(id)
    this.showLoading = true
    this.showModal = true
    this.modalImgPath = ''
    this.showLoading = false
  }
}
